import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type CargoSummaryQueryVariables = GraphQLTypes.Exact<{
  zencargoReference: GraphQLTypes.Scalars['String']['input'];
}>;

export type CargoSummaryQueryResult = { __typename?: 'Query' } & {
  bookings: { __typename?: 'BookingConnection' } & {
    nodes?: GraphQLTypes.Maybe<
      Array<
        GraphQLTypes.Maybe<
          { __typename?: 'Booking' } & Pick<GraphQLTypes.Booking, 'modeOfTransport' | 'zencargoReference'> & {
              calculatedInfo: { __typename?: 'CalculatedInfo' } & {
                cargoSummary?: GraphQLTypes.Maybe<
                  { __typename?: 'CargoSummary' } & Pick<
                    GraphQLTypes.CargoSummary,
                    'highestRiskLevel' | 'label' | 'totalActualCbm' | 'type'
                  > & {
                      totalChargeableWeight?: GraphQLTypes.Maybe<
                        Array<{ __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>>
                      >;
                      totalGrossWeight?: GraphQLTypes.Maybe<
                        Array<{ __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>>
                      >;
                      totalValueOfGoods?: GraphQLTypes.Maybe<
                        Array<{ __typename?: 'Money' } & Pick<GraphQLTypes.Money, 'currency' | 'value'>>
                      >;
                    }
                >;
              };
              canManageAssignedLots: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
              cargo?: GraphQLTypes.Maybe<
                { __typename?: 'Cargo' } & Pick<GraphQLTypes.Cargo, 'mode'> & {
                    consolidatedCargo?: GraphQLTypes.Maybe<
                      { __typename?: 'ConsolidatedCargo' } & {
                        consolidatedCargoItems?: GraphQLTypes.Maybe<
                          Array<
                            { __typename?: 'CargoConsolidatedItemType' } & Pick<
                              GraphQLTypes.CargoConsolidatedItemType,
                              'quantity' | 'subType' | 'type'
                            >
                          >
                        >;
                        consolidatedLooseCargoItems?: GraphQLTypes.Maybe<
                          Array<
                            { __typename?: 'ConsolidatedLooseCargoItem' } & Pick<
                              GraphQLTypes.ConsolidatedLooseCargoItem,
                              'quantity' | 'type'
                            >
                          >
                        >;
                      }
                    >;
                  }
              >;
            }
        >
      >
    >;
  };
};

export const CargoSummaryDocument = gql`
  query cargoSummary($zencargoReference: String!) {
    bookings(zencargoReferences: [$zencargoReference]) {
      nodes {
        calculatedInfo {
          cargoSummary {
            highestRiskLevel
            label
            totalActualCbm
            totalChargeableWeight {
              metric
              value
            }
            totalGrossWeight {
              metric
              value
            }
            totalValueOfGoods {
              currency
              value
            }
            type
          }
        }
        canManageAssignedLots {
          value
        }
        cargo {
          consolidatedCargo {
            consolidatedCargoItems {
              quantity
              subType
              type
            }
            consolidatedLooseCargoItems {
              quantity
              type
            }
          }
          mode
        }
        modeOfTransport
        zencargoReference
      }
    }
  }
`;
